import { debounce } from '@recruit-robin/robin-theme/web-utils';
import { useCallback, useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';

import { DialogContext } from '../../../DialogContext';

const CAMPAIGN_PHONE_REACH_OUT_DIALOG_LAST_POSITION = 'CAMPAIGN_PHONE_REACH_OUT_DIALOG_LAST_POSITION';

export const usePosition = ({ isVisible }: { isVisible: boolean }) => {
  const getMousePosition = useContextSelector(DialogContext, (s) => s.getMousePosition);

  const initialPosition = useMemo<{ x: number; y: number }>(() => {
    const lastPosition = localStorage.getItem(CAMPAIGN_PHONE_REACH_OUT_DIALOG_LAST_POSITION);

    if (lastPosition) {
      return JSON.parse(lastPosition);
    }

    const mousePosition = getMousePosition();

    if (!mousePosition) {
      return {
        x: window.innerWidth - 600 - 120,
        y: window.innerHeight / 2,
      };
    }

    return { x: mousePosition.x - 300, y: mousePosition.y + 50 };
  }, [getMousePosition, isVisible]);

  const debouncedHandlePositionChange = useCallback(
    debounce((position: { x: number; y: number }) => {
      localStorage.setItem(CAMPAIGN_PHONE_REACH_OUT_DIALOG_LAST_POSITION, JSON.stringify(position));
    }, 500),
    [],
  );

  return { initialPosition, debouncedHandlePositionChange };
};
